import { camelizeKeys, decamelizeKeys } from 'humps'

import Cookies from '@/utils/cookie-provider'
import CookieStorage from '@/utils/cookie-storage'
import { setKycToken } from '@/utils/auth'
import locator from '@/service-locator'
import clientLogger from '@/plugins/logger/core'
import router from '@/plugins/router'
import LOGGING_EVENTS from '@/constants/logging-events'
import SUPPORTED_CLIENT_TYPE from '@kyc/constants/supported-client-type'

const CACHE_KEY_NATIONAL_ID = 'kyc_national_id'
const CACHE_KEY_DOB = 'kyc_dob'

const KycSessionIDKey = 'tamara-kyc-id'
const KycQueryParams = 'tamara-kyc-query-params'

export const getKycSessionId = () => {
  return Cookies.get(KycSessionIDKey)
}

export const setKycSessionId = (kycSessionId) => {
  return Cookies.set(
    KycSessionIDKey,
    kycSessionId,
    CookieStorage.getCookieAttributes(window)
  )
}

export const removeKycSessionId = () => {
  return Cookies.remove(
    KycSessionIDKey,
    CookieStorage.getCookieAttributes(window)
  )
}

export const setKycQueryParams = (data) => {
  window.storage.setItem(KycQueryParams, JSON.stringify(data))
}

export const getKycQueryParams = () => {
  try {
    const data = window.storage.getItem(KycQueryParams)

    return JSON.parse(data)
  } catch (_) {
    return {}
  }
}

export const KYC_STAGE = {
  NONE: 'NONE',
  UNKNOWN: 'UNKNOWN',
  ID_INPUT: 'personal_data_verification',
  NAFATH_WAITING: 'nafath_id_verification_waiting',
  ID_VERIFICATION_CONFIRM: 'absher_verification_waiting',
  SPENDING_INPUT: 'credit_evaluation',
  SPENDING_APPROVED: 'get_customer_credit_limit',
  CREDIT_UNDERWRITING: 'credit_underwriting',
  QUESTIONNAIRE_SUBMISSION: 'questionnaire_submission',
  FINISH: 'finish',
  ERROR: 'ERROR',
}

export const resolveStateFromKycData = (kycData) => {
  return {
    data: camelizeKeys(kycData),
    stage: kycData?.step,
  }
}

export const isValidStage = (stage) =>
  Object.values(KYC_STAGE).indexOf(stage) > -1

export const getCachedNationalId = () => {
  return window.storage?.getItem(CACHE_KEY_NATIONAL_ID) || ''
}

export const getCachedDob = () => {
  return window.storage?.getItem(CACHE_KEY_DOB) || ''
}

export const cacheNationalId = (value) => {
  window.storage.setItem(CACHE_KEY_NATIONAL_ID, value)
}

export const cacheDob = (value) => {
  window.storage.setItem(CACHE_KEY_DOB, value)
}

export const redirectToKycPage = (queryData) => {
  setKycToken(locator.store.getters.token)

  const isSimpleCheckoutEnabled =
    locator.store.getters['configuration/isSimpleCheckoutEnabled']
  const locale = locator.store.getters['application/currentLocale']
  const currency = locator.store.getters['session/orderCurrency']
  const clientType = isSimpleCheckoutEnabled
    ? SUPPORTED_CLIENT_TYPE.simple_checkout
    : SUPPORTED_CLIENT_TYPE.checkout

  const { query: currentQuery = {}, path = '' } = router || {}
  const query = {
    client_type: clientType,
    locale,
    currency,
    ...decamelizeKeys(queryData),
    ...currentQuery,
    redirectFrom: path,
  }

  clientLogger.log(LOGGING_EVENTS.REDIRECT_TO_KYC, {
    redirectUrl: `/kyc?${new URLSearchParams(query).toString()}`,
  })

  router.push({
    name: 'kyc',
    query,
  })
}

export const QUESTIONS_BLACKLISTED = ['monthly_debt']

export const FEATURE_GATE_QUESTIONNAIRE_REVAMP =
  'finance-questionnaire-revamp-2'
